import React, {Component} from 'react';
import {Dialog, Spinner, Form} from '../widgets/';
import {connect} from 'react-redux';
import {uiActions} from '../chrome';
import './LoginDialog.css';
import {postJson} from '../fetchJson';

class ForgotPassword extends Component {
	constructor() {
		super();

		this.state = {
			navigating: false,
			email: '',
			error: false
		};

		this.changeUsername = e => this.setState({email: e.target.value});

		this.handleKeyPress = e => {
			if (e.key === 'Enter' && this.state.email && this.state.email.length) {
				this.reset();
			}
		};
		this.navigated = () => {
			this.setState({navigating: true});
		};

		this.reset = () => {
			this.setState({
				navigating: true,
				error: false
			});

			postJson(`/api/user/${encodeURIComponent(this.state.email)}/reset/request`, {})
				.then(() => {
					this.props.onReset();
				})
				.catch(() => {
					this.setState({
						error: true
					});
				});
		};
	}

	render() {
		return (
			<Dialog
				buttons={['cancel', 'reset']}
				disabled={{
					reset: !this.state.email
				}}
				onReset={this.reset}
				onCancel={this.props.onCancel}
				title={'Request password reset'}
				emphasis={'reset'}>
				<div className="LoginDialog">
					<p>
						Enter your email address below to reset or change your <em>B2Me</em> password:
					</p>

					<Form>
						<div className="LoginDialog-field">
							<label htmlFor="email">Email address</label>
							<input
								id="email"
								type="text"
								onKeyPress={this.handleKeyPress}
								onChange={this.changeUsername}
								value={this.state.email}
							/>
						</div>
					</Form>
					{this.state.navigating && <Spinner />}
					{this.state.error && (
						<div className="LoginDialog-error">
							<span className="icon icon-error" />
							<span>The email you entered was incorrect.</span>
						</div>
					)}
				</div>
			</Dialog>
		);
	}
}

const ConnectedForgotPassword = connect(
	state => ({
		modal: state.ui.modal
	}),
	dispatch => ({
		onReset: () => {
			dispatch(uiActions.uiModal(null));
			dispatch(uiActions.uiMessage(`A password reset link has been sent to your email`));
		},
		onCancel: () => dispatch(uiActions.uiModal(null))
	})
)(ForgotPassword);

export default ConnectedForgotPassword;



// WEBPACK FOOTER //
// ./src/user/ForgotPassword.js